import React, { useState } from "react";

import {
  BarChart, Area, ScatterChart, ZAxis, Scatter,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  Legend, CartesianGrid
} from "recharts";
import "./Css/Dashboard.css";

const stats = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.544553 14.6991H2.38238C2.97277 13.838 4.23925 13.3886 5.37241 12.9858C5.65237 12.8855 5.92471 12.7906 6.1723 12.6922C6.3037 12.5293 6.41036 12.3556 6.49415 12.1676C6.56652 12.0065 6.61985 11.8364 6.65603 11.6574C6.45416 11.5446 6.2599 11.4103 6.07517 11.2563C5.3229 10.6297 4.79726 10.1177 4.45826 9.52511C4.11355 8.92356 3.97072 8.25757 3.98976 7.33018L4.04309 5.20687C4.04309 5.17644 4.0488 5.14958 4.05832 5.12273L3.39366 4.90789C3.29843 2.87231 4.5173 1.65132 6.02375 1.03724C6.57414 0.81345 5.65237 -0.314447 6.91695 0.0847929C8.60622 0.616516 12.3504 1.30937 13.2379 2.26897C13.9597 3.04955 13.9883 3.47743 13.9711 4.50507C13.9654 4.83807 13.9102 5.13168 13.7407 5.2391C13.6626 5.28744 13.5693 5.30534 13.4627 5.2946V7.52533C13.4627 8.79645 12.9789 9.8581 12.2362 10.6458C11.8172 11.0898 11.3182 11.4443 10.7754 11.7003C10.8078 11.8633 10.8535 12.0208 10.9106 12.1694C10.9773 12.3431 11.063 12.5096 11.1639 12.6671C11.3811 12.7584 11.5963 12.8408 11.8115 12.9231C12.8704 13.3313 13.9464 13.7449 14.5025 14.6973H16.426C16.7803 14.6973 17.0678 15.0285 16.9859 15.4331L15.8071 21.2642C15.7271 21.6616 15.4547 22 15.0243 22H2.18241C1.75199 22 1.49298 21.6598 1.39966 21.2642L0.0189159 15.4349C-0.0763082 15.0303 0.201746 14.6991 0.544553 14.6991ZM8.53195 17.4454C9.04997 17.4454 9.47086 17.8411 9.47086 18.3281C9.47086 18.815 9.04997 19.2107 8.53195 19.2107C8.01393 19.2107 7.59304 18.815 7.59304 18.3281C7.59304 17.8411 8.01393 17.4454 8.53195 17.4454ZM7.64827 12.0477C7.47877 12.0065 7.31308 11.9528 7.1512 11.8901C7.11121 12.053 7.05598 12.2106 6.98932 12.3628C6.90362 12.5525 6.79697 12.7351 6.66746 12.907C6.8103 13.0556 6.97027 13.1827 7.14549 13.2883C7.6178 13.5748 8.18533 13.7091 8.74525 13.6965C9.30136 13.684 9.84414 13.5247 10.2707 13.2221C10.4174 13.1165 10.5507 12.9947 10.665 12.8569C10.5659 12.694 10.4802 12.5221 10.4117 12.3413C10.3583 12.2034 10.3145 12.0602 10.2803 11.9134C9.73558 12.096 9.18519 12.1873 8.64622 12.1801C8.30532 12.173 7.97203 12.13 7.64827 12.0477ZM7.09406 11.3065C7.26928 11.3942 7.4502 11.464 7.63303 11.5213C7.97584 11.6216 8.33579 11.6717 8.69573 11.6717V11.6735C9.26708 11.6735 9.84604 11.5517 10.3869 11.3208C10.9278 11.0898 11.4268 10.7497 11.8362 10.3164C12.4971 9.61641 12.9256 8.66934 12.9256 7.52891V5.76366C12.9199 5.59537 12.8951 5.44141 12.8494 5.30176C12.8056 5.16749 12.7409 5.04754 12.6532 4.94549C12.3257 4.56057 12.0152 4.56415 11.5715 4.56594C11.5315 4.56594 11.4896 4.56594 11.4344 4.56594C9.68035 4.56057 8.53195 4.50686 7.59875 4.3887C6.73793 4.27949 6.06374 4.11657 5.27909 3.88383C5.20482 4.03959 5.11912 4.18998 5.01818 4.33857C4.89058 4.52656 4.74013 4.70559 4.57063 4.87567L4.51921 7.34272C4.50207 8.177 4.62776 8.7696 4.92486 9.29237C5.22767 9.8223 5.71903 10.2967 6.42369 10.8857C6.61033 11.0415 6.8103 11.1722 7.01789 11.2814C7.04836 11.2832 7.07312 11.2921 7.09406 11.3065ZM10.8821 6.62659C11.2001 6.62659 11.4591 6.87007 11.4591 7.16906C11.4591 7.46804 11.2001 7.71152 10.8821 7.71152C10.564 7.71152 10.305 7.46804 10.305 7.16906C10.305 6.87007 10.5621 6.62659 10.8821 6.62659ZM6.52843 6.62659C6.84648 6.62659 7.10549 6.87007 7.10549 7.16906C7.10549 7.46804 6.84648 7.71152 6.52843 7.71152C6.21039 7.71152 5.95138 7.46804 5.95138 7.16906C5.95138 6.87007 6.21039 6.62659 6.52843 6.62659ZM7.52448 9.77396C7.40069 9.69877 7.36641 9.54301 7.44639 9.42664C7.52638 9.31027 7.69207 9.27804 7.81586 9.35324C8.12058 9.53943 8.41197 9.63969 8.69002 9.64327C8.95855 9.64685 9.22518 9.55733 9.488 9.36577C9.60417 9.27983 9.77367 9.29953 9.86318 9.41053C9.9546 9.51974 9.93365 9.67728 9.81557 9.76322C9.45372 10.0282 9.07473 10.1499 8.6824 10.1463C8.2996 10.1392 7.91299 10.0103 7.52448 9.77396ZM3.06228 14.6991H13.8664C13.3522 14.06 12.4742 13.7216 11.6096 13.3886C11.4287 13.3188 11.2496 13.249 11.0763 13.1791C10.9316 13.3635 10.7564 13.5229 10.5583 13.6589C10.0803 13.9848 9.46324 14.1728 8.82524 14.2014C8.19105 14.23 7.534 14.1029 6.97408 13.7986C6.69412 13.6482 6.43892 13.4531 6.22372 13.2149C6.01232 13.2955 5.7895 13.3743 5.56096 13.4548C4.6449 13.7807 3.63743 14.1387 3.06228 14.6991Z" fill="white" />
      </svg>
    ),
    title: "एकूण विद्यार्थी",
    value: "1500",
    sub: "↑ 4% या महिन्यात वाढ",
    color: "pink",
  },
  {
    icon: (<svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
      <g clip-path="url(#clip0_1056_17217)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9211 8.27946V6.75408C15.9924 6.45916 16.0915 6.42987 16.2401 6.40252C16.6403 6.34198 16.5947 8.17985 15.9211 8.27946ZM16.4025 18.2618C16.4006 18.2462 16.3986 18.2305 16.3986 18.211C16.3986 18.1954 16.4006 18.1778 16.4025 18.1622V17.0841C15.4991 17.0118 14.564 17.0938 13.7497 17.3536C12.9869 17.5958 12.3311 17.9903 11.9052 18.5586V23.0488C12.5689 22.6797 13.2464 22.5156 13.9438 22.3067C14.7383 22.0703 15.5566 21.9571 16.4025 22.0156V18.2618ZM11.1226 23.1289V18.5508C10.7125 17.9473 10.0507 17.543 9.30184 17.3028C8.45387 17.0313 7.50091 16.9708 6.66879 17.0684L6.6252 22.0371C7.53062 22.0098 8.41821 22.1055 9.25032 22.334C9.91601 22.5137 10.546 22.7793 11.1226 23.1289ZM17.302 23.2559C16.4857 23.0977 15.6754 22.9981 14.871 22.9942C13.825 22.9883 12.7789 23.5586 11.7288 23.9453C11.6635 23.9805 11.5862 24 11.5069 24C11.4277 24 11.3504 23.9824 11.2831 23.9453C8.75502 23.0098 8.4301 22.7227 5.69007 23.2598C5.69007 21.709 5.74554 20.6973 5.79705 19.6817H1.19071C0.443794 19.629 0.0633991 19.2461 0 18.5879C0.257559 17.4571 0.318977 16.6973 1.02825 15.7755C1.31355 15.4044 1.66621 15.129 2.05849 14.9161C3.29873 14.2345 7.2592 14.0353 8.38453 13.0353L9.65449 16.7169C9.91403 16.8028 10.1637 16.9063 10.3994 17.0294L10.974 15.0665L10.55 14.6095C10.3598 14.3341 10.3162 14.0919 10.4232 13.8868C10.653 13.4376 11.1285 13.5216 11.5743 13.5216C12.0399 13.5216 12.6144 13.4357 12.761 14.0079C12.8106 14.1993 12.7472 14.4005 12.6125 14.6095L12.1885 15.0665L12.761 17.0255C12.981 16.9219 13.2128 16.8302 13.4545 16.754L14.6155 13.0372C15.7408 14.0353 19.7013 14.2364 20.9395 14.9181C21.3298 15.1349 21.6865 15.4083 21.9717 15.7774C22.681 16.6993 22.7405 17.4591 23 18.5899C22.9366 19.25 22.5562 19.6309 21.8093 19.6856H17.2346C17.2663 20.7051 17.302 21.6914 17.302 23.2559ZM8.88578 6.62908C8.80059 6.66228 8.70945 6.60955 8.67775 6.51776C8.64803 6.42205 8.6936 6.31854 8.77879 6.28729C9.4326 6.03729 9.89818 6.05292 10.554 6.28729C10.6392 6.31854 10.6867 6.4201 10.661 6.5158C10.6352 6.6115 10.5421 6.66424 10.4589 6.63494C10.3499 6.59783 10.2409 6.56268 10.132 6.53924C10.1439 6.57635 10.1498 6.61736 10.1498 6.66033C10.1498 6.90838 9.94771 7.1115 9.69214 7.1115C9.44052 7.1115 9.23447 6.90838 9.23447 6.66033C9.23447 6.59783 9.24636 6.54119 9.26815 6.48846C9.07598 6.50799 9.07994 6.55486 8.88578 6.62908ZM12.6303 6.62908C12.5451 6.66228 12.454 6.60955 12.4223 6.51776C12.3925 6.42205 12.4381 6.31854 12.5233 6.28729C13.1751 6.03729 13.6427 6.05292 14.2985 6.28729C14.3837 6.31854 14.4312 6.4201 14.4055 6.5158C14.3797 6.6115 14.2866 6.66424 14.2034 6.63494C14.0944 6.59783 13.9854 6.56268 13.8765 6.53924C13.8884 6.57635 13.8943 6.61736 13.8943 6.66033C13.8943 6.90838 13.6902 7.1115 13.4366 7.1115C13.185 7.1115 12.981 6.90838 12.981 6.66033C12.981 6.59783 12.9929 6.54119 13.0146 6.48846C12.8185 6.50799 12.8244 6.55486 12.6303 6.62908ZM10.9879 8.65055C10.9106 8.58609 10.8987 8.47086 10.9641 8.39469C11.0295 8.31852 11.1464 8.3068 11.2236 8.37125C11.3167 8.44938 11.4059 8.48844 11.4891 8.48844C11.5743 8.49039 11.6674 8.45133 11.7665 8.3693C11.8437 8.30485 11.9606 8.31852 12.026 8.39469C12.0914 8.47086 12.0795 8.58609 12.0003 8.65055C11.8319 8.78726 11.6575 8.85367 11.4851 8.84976C11.3108 8.84781 11.1464 8.77945 10.9879 8.65055ZM12.8958 10.0275C12.7452 10.0783 12.5887 10.1212 12.4282 10.1564C12.2618 10.2013 12.1112 10.2287 11.9765 10.2326C11.8219 10.2345 11.6892 10.2072 11.5842 10.1388C11.5525 10.1173 11.5228 10.0958 11.497 10.0705C11.4713 10.0939 11.4435 10.1173 11.4099 10.1388C11.3049 10.2091 11.1721 10.2365 11.0176 10.2326C10.8829 10.2287 10.7303 10.2033 10.5659 10.1564C10.4054 10.1212 10.2489 10.0783 10.0963 10.0275C9.94573 9.97671 9.79714 9.91811 9.65449 9.85171C9.58515 9.82046 9.55741 9.74429 9.59307 9.67983C9.61487 9.64272 9.65251 9.61733 9.69412 9.61147C9.77139 9.59976 9.8328 9.59194 9.89026 9.58413L9.89422 9.58218C10.0805 9.55679 10.2211 9.53726 10.3955 9.4689C10.445 9.44937 10.4925 9.42788 10.5401 9.4064C10.8175 9.27945 11.1206 9.14273 11.4237 9.37906C11.4495 9.40054 11.4733 9.42007 11.495 9.44351C11.5168 9.42007 11.5406 9.40054 11.5664 9.37906C11.8675 9.14078 12.1726 9.27945 12.45 9.4064C12.4975 9.42788 12.5451 9.44937 12.5946 9.4689C12.769 9.53726 12.9116 9.55679 13.0959 9.58218L13.1018 9.58413C13.1593 9.59194 13.2207 9.59976 13.298 9.61147C13.3396 9.61929 13.3792 9.64272 13.399 9.67983C13.4347 9.74233 13.4069 9.82046 13.3376 9.85171C13.1949 9.91811 13.0463 9.97671 12.8958 10.0275ZM6.15566 3.54904V2.87521C6.2983 1.70726 6.84908 1.23851 7.75648 1.37328C8.61633 0.486566 9.8328 -0.00952271 11.5089 0.00219592C13.3732 -0.0349131 14.9642 0.39477 16.1172 1.56077C16.7235 2.15647 16.983 2.77756 16.8265 4.09005C16.8582 5.37714 17.0028 5.48261 16.5789 5.70917C16.5769 5.74433 16.5749 5.77948 16.5729 5.81659L16.2817 5.99823C16.5174 5.98065 16.6819 6.12518 16.7809 6.37127C16.8285 6.49432 16.8602 6.64471 16.8741 6.80877C16.886 6.96111 16.884 7.13103 16.8622 7.3029C16.7928 7.9279 16.5016 8.58023 15.9627 8.65641C15.9389 8.66031 15.9152 8.66031 15.8934 8.65836V8.73844C15.8934 8.74234 15.8934 8.74625 15.8934 8.75015C15.929 9.62319 15.4615 10.5919 14.7066 11.3673C13.3336 12.7794 11.079 13.4825 9.11956 11.8829C8.77879 11.6036 8.38255 11.3302 8.0715 10.8986C8.07546 10.8947 8.07942 10.8908 8.0814 10.8888L8.07348 10.8829C7.56827 10.4201 7.33052 10.2013 7.12844 9.25015C7.12447 9.23257 7.12249 9.21109 7.12249 9.19351V8.65836C7.09475 8.66422 7.06504 8.66422 7.03532 8.65836C6.49444 8.58024 6.20519 7.9279 6.13584 7.30486C6.11801 7.13298 6.11405 6.96306 6.12396 6.81072C6.13782 6.64666 6.16952 6.49627 6.21707 6.37323C6.32406 6.10565 6.51029 5.95721 6.77776 6.008C6.90654 6.03143 7.02541 6.09588 7.12249 6.20721V5.99042L6.90456 5.86932C6.8788 5.69354 6.87484 5.51581 6.88673 5.33417C6.49246 4.68379 6.18537 4.05098 6.15566 3.54904ZM15.3109 5.72284C15.0533 5.00996 14.7126 4.92988 14.0904 4.55488C13.5694 4.33223 13.1117 4.14278 12.6778 4.00802C11.6258 3.77755 10.4708 3.84395 9.51383 4.1584C9.26023 4.25606 8.9888 4.3752 8.69954 4.51778C8.08933 4.86933 7.80601 4.90449 7.67723 5.50409V9.1896C7.89517 10.2169 7.87932 10.0255 8.54699 10.6701L9.70601 11.7872C9.91601 11.9572 10.1518 12.0568 10.4014 12.1154C11.2593 12.3146 13.0602 12.2345 13.7358 11.5333C14.7423 10.5685 15.3763 10.2775 15.3049 8.73453V5.72284H15.3109ZM10.546 10.8947C10.4628 10.8497 10.4311 10.7462 10.4747 10.6662C10.5203 10.5841 10.6253 10.5509 10.7065 10.5958C10.972 10.7345 11.2315 10.8048 11.4891 10.8068C11.7447 10.8068 12.0022 10.7384 12.2598 10.5978C12.343 10.5529 12.448 10.5822 12.4936 10.6642C12.5392 10.7462 12.5094 10.8478 12.4262 10.8947C12.1172 11.0626 11.8061 11.1466 11.4911 11.1427C11.1741 11.1408 10.8591 11.0587 10.546 10.8947ZM7.07296 8.27946V6.75408C7.00164 6.45916 6.91644 6.44549 6.76983 6.41815C6.37161 6.3576 6.37953 8.13297 7.07296 8.27946Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_1056_17217">
          <rect width="23" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>),
    title: "एकूण शिक्षक",
    value: "45",
    sub: "↑ 2 नवीन शिक्षक जोडले",
    color: "yellow",
  },
  {
    icon: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9.3845 8.3845V7.3845H17.6155V8.3845H9.3845ZM9.3845 11.1538V10.1538H17.6155V11.1538H9.3845ZM14.2308 21V18.7905L19.5635 13.4827C19.6622 13.3968 19.7647 13.3333 19.8712 13.2923C19.9776 13.2513 20.084 13.2308 20.1905 13.2308C20.3007 13.2308 20.4122 13.2522 20.525 13.2952C20.6378 13.3381 20.7372 13.4025 20.823 13.4885L21.748 14.4327C21.8302 14.5314 21.8927 14.634 21.9355 14.7405C21.9785 14.8468 22 14.9532 22 15.0595C22 15.166 21.9827 15.2734 21.948 15.3818C21.9135 15.4901 21.8468 15.5936 21.748 15.6923L16.4405 21H14.2308ZM20.1905 16.0155L21.1155 15.0595L20.1905 14.1155L19.2405 15.0655L20.1905 16.0155ZM6 21C5.43583 21 4.9615 20.8077 4.577 20.423C4.19233 20.0385 4 19.5642 4 19V16.2308H7V3H20V10.8712C19.8205 10.8762 19.6497 10.8952 19.4875 10.928C19.3253 10.9607 19.1628 11.0071 19 11.0673V4H8V16.2308H13.3462L11.8463 17.7308V21H6Z" fill="white" />
    </svg>),
    title: "एकूण परीक्षा",
    value: "78",
    sub: "५ परीक्षा जोडल्या ",
    color: "green",
  },
  {
    icon: (<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
      <path d="M14.5003 22.6795C13.5182 22.0071 12.4632 21.4904 11.3354 21.1295C10.2076 20.7686 9.04732 20.5882 7.85449 20.5882C7.22556 20.5882 6.60779 20.6409 6.00121 20.7462C5.39483 20.8515 4.80426 21.0204 4.22949 21.2528C3.79107 21.4278 3.37943 21.3751 2.99458 21.0948C2.60952 20.8145 2.41699 20.4272 2.41699 19.933V8.25382C2.41699 7.95476 2.49563 7.67745 2.65292 7.42189C2.8102 7.16632 3.03052 6.9882 3.31388 6.8875C4.02337 6.57454 4.76156 6.34758 5.52845 6.20661C6.29534 6.06563 7.07069 5.99515 7.85449 5.99515C9.1744 5.99515 10.3463 6.1625 11.3701 6.49721C12.3942 6.83172 13.4407 7.32814 14.5097 7.98648C14.7002 8.09201 14.8469 8.23298 14.9498 8.4094C15.0529 8.58602 15.1045 8.78982 15.1045 9.02081V20.9274C16.0836 20.3807 17.0717 19.986 18.0685 19.7436C19.0654 19.5011 20.0913 19.3799 21.1462 19.3799C21.8712 19.3799 22.523 19.4248 23.1015 19.5146C23.6801 19.6044 24.1902 19.7237 24.6316 19.8726C24.8177 19.9499 24.9882 19.9382 25.143 19.8375C25.2979 19.7368 25.3753 19.578 25.3753 19.3611V6.75972C25.445 6.78288 25.5136 6.80846 25.581 6.83645C25.6483 6.86424 25.7145 6.89676 25.7795 6.93402C26.0476 7.05022 26.2487 7.22835 26.3828 7.46841C26.5167 7.70846 26.5837 7.97027 26.5837 8.25382V19.933C26.5837 20.4272 26.3757 20.8067 25.9599 21.0715C25.5438 21.3364 25.101 21.3813 24.6316 21.2063C24.0725 20.9894 23.5013 20.8321 22.9179 20.7344C22.3347 20.6369 21.7441 20.5882 21.1462 20.5882C19.9533 20.5882 18.793 20.7686 17.6653 21.1295C16.5375 21.4904 15.4825 22.0071 14.5003 22.6795ZM18.3576 16.9167V4.83333L22.1222 3.625V15.7083L18.3576 16.9167Z" fill="white" />
    </svg>),
    title: "एकूण विकलेली पुस्तके",
    value: "45",
    sub: "१२% कमिशन ",
    color: "purple",
  },
];

const chartData = [
  {
    name: "पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा",
    पास: 850,
    नापास: 320,
  },
  {
    name: "नवोदय विद्यालय प्रवेश परीक्षा",
    पास: 920,
    नापास: 260,
  },
  {
    name: "NMMS Exam",
    पास: 780,
    नापास: 410,
  },
];

const subjectData = [
  { name: "भाषा", value: 85 },
  { name: "गणित", value: 70 },
  { name: "इंग्रजी", value: 40 },
  { name: "बुद्धिमत्ता", value: 80 },
];

const examData = [
  { name: "पूर्व उच्च प्राथमिक परीक्षा", value: 60 },
  { name: "जिल्हा स्तर परीक्षा", value: 25 },
  { name: "NMMS Exam", value: 15 },
];

const monthData = [
  { name: "जाने", value: 220 },
  { name: "फेब्रु", value: 100 },
  { name: "मार्च", value: 200 },
  { name: "एप्रि", value: 70 },
  { name: "मे", value: 180 },
  { name: "जून", value: 210 },
  { name: "जुलै", value: 90 },
  { name: "ऑग", value: 130 },
  { name: "सप्टे", value: 160 },
  { name: "ऑक्टो", value: 190 },
  { name: "नोव्हे", value: 220 },
  { name: "डिसें", value: 240 },
];

const COLORS = ["#14B8A6", "#3B82F6", "#FACC15"];

const cards = [
  {
    title: "यंदाचा सरासरी निकाल",
    subtitle: "यावर्षी जाहीर झालेला निकाल",
    percent: 77,
    color: "#FEAD36",
  },
  {
    title: "कमी कामगिरी करणारे विषय",
    subtitle: "विज्ञान • ४८%",
    percent: 54,
    color: "#F452E9",
  },
  {
    title: "एकूण प्रश्नांतील प्रश्न",
    subtitle: "मागील महिन्यात जोडलेले प्रश्न",
    percent: 39,
    color: "#747BB4",
  },
];

export default function Dashboard() {
  const [activeIndex, setActiveIndex] = useState(null);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const onPieLeave = () => {
    setActiveIndex(null);
  };

  return (
    <div className="dashboard">
      <div className="page-header">
        <h3>
          <span>नमस्कार ज्ञानदीप विद्यालय </span>
        </h3>

      </div>
      <div className="dashboard-row">
        <div className="border">
          <div className="filter-row">
            <select className="filter-select">
              <option>महिना निवडा</option>
              <option>जानेवारी</option>
              <option>फेब्रुवारी</option>
              <option>मार्च</option>
              <option>एप्रिल</option>
              <option>मे</option>
              <option>जून</option>
              <option>जुलै</option>
              <option>ऑगस्ट</option>
              <option>सप्टेंबर</option>
              <option>ऑक्टोबर</option>
              <option>नोव्हेंबर</option>
              <option>डिसेंबर</option>
            </select>
          </div>
          <div className="cards-chart-row">
            <div className="stats-grid">
              {stats.map((item, index) => (
                <div key={index} className={`stat-card ${item.color}`}>
                  <div className="icon-bg">
                    {item.icon}
                  </div>
                  <h3 className="count">{item.value}</h3>
                  <p className="titles">{item.title}</p>
                  <span className="sub">{item.sub}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="chart-cards">
          <h3 className="graph-title">विद्यार्थी परीक्षा निकाल</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} barSize={28}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fontSize: 10 }} />
              <YAxis ticks={[0, 250, 500, 750, 1000, 1250]} domain={[0, 1250]} />
              <Tooltip />
              <Legend />
              <Bar dataKey="पास" fill="#54FF6E" />
              <Bar dataKey="नापास" fill="#FF6060" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="chart-row">
        <div className="chart-cardd chart-card-small">
          <h3 className="graph-title">विषयानुसार कामगिरी</h3>
          <div className="chart-header">
            <select className="filter-select">
              <option> परीक्षेचे नाव</option>
              <option>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा </option>
              <option>ज. नवोदय विद्यालय प्रवेश परीक्षा</option>
              <option>NMMS Exam</option>
            </select>
            <select className="filter-select">
              <option> इयत्ता</option>
              <option>५ वी</option>
              <option>६ वी</option>
              <option>७ वी</option>
            </select>
          </div>
          <ResponsiveContainer width="100%" height={270}>
            <BarChart
              data={subjectData}
              layout="vertical"
              margin={{ top: 20, right: 5, left: 0, bottom: 10 }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={true}
                vertical={true}
              />
              <XAxis
                type="number"
                domain={[0, 100]}
                ticks={[0, 20, 40, 60, 80, 100]}
                tickFormatter={(v) => `${v}%`}
                orientation="top"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 13 }}
              />
              <YAxis
                type="category"
                dataKey="name"
                axisLine={false}
                tickLine={false}
                width={70}
                tick={{ fontSize: 12 }}
              />
              <Tooltip formatter={(v) => `${v}%`} />
              <Bar
                dataKey="value"
                fill="#8EA0FF"
                barSize={25}
                radius={[0, 0, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="chart-cardd chart-card-small">
          <h3 className="graph-title">विषयानुसार कामगिरी</h3>
          <div className="filter-row">
            <select className="filter-select">
              <option>महिना निवडा</option>
              <option>जानेवारी</option>
              <option>फेब्रुवारी</option>
              <option>मार्च</option>
              <option>एप्रिल</option>
              <option>मे</option>
              <option>जून</option>
              <option>जुलै</option>
              <option>ऑगस्ट</option>
              <option>सप्टेंबर</option>
              <option>ऑक्टोबर</option>
              <option>नोव्हेंबर</option>
              <option>डिसेंबर</option>
            </select>
          </div>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={examData}
                dataKey="value"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={false}
                onMouseEnter={onPieEnter}
                onMouseLeave={onPieLeave}
              >
                {examData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              {activeIndex !== null && (
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fill="#ffffff"
                  fontSize="22"
                  fontWeight="700"
                >
                  {examData[activeIndex].value}
                </text>
              )}
            </PieChart>
          </ResponsiveContainer>
          <div className="legend">
            <span className="l1">पूर्व उच्च प्राथमिक परीक्षा</span>
            <span className="l2">जिल्हा स्तर परीक्षा</span>
            <span className="l3">NMMS Exam</span>
          </div>
        </div>
        <div className="chart-cardd chart-card-large">
          <div className="chart-header">
            <h3 className="graph-title">एकूण पुस्तके विक्री</h3>
            <div className="filter-row">
              <select className="filter-select">
                <option>वर्ष</option>
                <option>2024</option>
                <option>2025</option>
              </select>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={monthData} barSize={18}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="name"
                interval={0}
                tick={{ fontSize: 10 }}
              />
              <YAxis
                ticks={[0, 50, 100, 150, 200, 250]}
                domain={[0, 250]}
                tick={{ fontSize: 12 }}
              />
              <Tooltip />
              <Bar
                dataKey="value"
                fill="#2FA8A1"
                radius={[0, 0, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="summary-roww">
        {cards.map((card, index) => (
          <div className="summary-cardo" key={index}>
            <div
              className="progress-circle"
              style={{
                background: `conic-gradient(${card.color} ${card.percent * 3.6}deg, #eee 0deg)`,
              }}
            >
              <div className="progress-inner">
                <span className="completed-text">Completed</span>
                <span
                  className="percent-text"
                  style={{ color: card.color }}
                >
                  {card.percent}%
                </span>
              </div>
            </div>
            <div className="card-text">
              <h4>{card.title}</h4>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
